import {PostRefundCreateRequest} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRefundPostCreateRequest} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makePostRefundCreateRequest = (): PostRefundCreateRequest =>
	new RemoteRefundPostCreateRequest(
		makeBFFApiUrl(RefundFlowEndPoints.protocol),
		makeAuthorizeHttpClientDecorator(),
	);
